import { css as i } from "styled-components";
const t = {
  base: ({ theme: s }) => /* @__PURE__ */ i([
    "display:inline-block;svg{width:100%;height:100%;}",
    ""
  ], s.components.forms.focusActiveState)
};
export {
  t as default
};
